import React from "react";
import classnames from "classnames";
import { View } from "@instructure/ui-view";
import { Heading } from "@instructure/ui-heading";
import styles from "./NavHeader.module.scss";

const customDevWatermark = require("./watermark.png")

const IasNavHeader = ({ title = "Create Course" }) => {
  return (
    <View
      as="header"
      className={classnames(styles.NavHeader)}
      background={"primary"}
      padding={"small none small"}
      margin={"none none medium"}
      borderWidth={"none none small"}
      borderColor={"secondary"}
    >
      <Heading>{title}</Heading>
      <span className="logo">
        <img style={{width: '185px', height: '17px', float: 'right', opacity: '0.4', marginRight: '20px'}} src={customDevWatermark} />
      </span>
    </View>
  );
};

export default IasNavHeader;
